// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1UserDisplaySchema = z.object({
  id: z.number().int().gt(0),
  email: z.coerce.string().min(1),
  name: z.coerce.string().min(1),
  avatar: z.object({
    large_retina: z.coerce.string().min(1),
    large: z.coerce.string().min(1),
    medium_retina: z.coerce.string().min(1),
    medium: z.coerce.string().min(1),
    timeline: z.coerce.string().min(1),
  }),
  updated_at: z.coerce.string().min(1),
});
